import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cpfMask]',
})
export class CpfMaskDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    if (!event.target.value) {
      return;
    }

    const value = event.target.value.replace(/\D/g, '');
    const part1 = value.substring(0, 3);
    const part2 = value.substring(3, 6);
    const part3 = value.substring(6, 9);
    const part4 = value.substring(9, 11);

    const formattedValue = `${part1}${part2 ? '.' + part2 : ''}${
      part3 ? '.' + part3 : ''
    }${part4 ? '-' + part4 : ''}`;
    this.control.control?.setValue(formattedValue, { emitEvent: false });
  }
}
